// If using a module system (e.g. via vue-cli), import Vue and VueI18n and then call Vue.use(VueI18n).
// import Vue from 'vue'
// import VueI18n from 'vue-i18n'
//
// Vue.use(VueI18n)

// Ready translated locale messages
const messages = {
  en: {
    price_list: "Price list",
    uploaded_files: "Uploaded files",
    tuning_type: "Tuning type",
    create_new_ticket: "Create new ticket",
    vehicle_type: "Vehicle type",
    special_instructions_put_here:
      "If you have special instructions, please write them down here",
    login: "Login",
    email_address: "Email address",
    password: "Password",
    toggle_navigation: "Toggle navigation",
    login_failed_try_or_reset: "Login failed. Try again or reset your password",
    lets_go: "Let's go",
    create_account: "Create account",
    forgot_your_password: "Forgot your password",
    forgot_password: "Forgot password",
    register: "Register",
    logged_out: "Logged out",
    logged_in: "Logged in",
    sorry_login_failed_check_credentials:
      "Sorry, login failed. Check your credentials or reset your password. If you still cannot login, please contact your accountmanager",
    back_to_login: "Back to login",
    request_reset: "Request reset",
    request_sent_please_check_mailbox:
      "Request sent - please check your mailbox for the reset link",
    something_went_wrong_check_email:
      "Something went wrong. Please check your emailaddress.",
    looking_to_login: "Looking to login",
    register_today_start_uploading:
      "Register today and start uploading your files",
    great: "Great",
    almost_on_board:
      "You're almost on board, walk through the registration wizard and let's go!",
    free_account: "Free account",
    creating_account_is_free:
      "Creating your account is free. You can then choose some credits you want to buy to start uploading files.",
    awesome_performances: "Awesome performances",
    we_provide_fast_stable_fileservice:
      "We provide you with a fast and stable fileservice. You can help your customers easy and efficient",
    friendly_support: "Friendly Support",
    we_can_help_issues: "We can help you with issues via our ticket system",
    companies_welcome: "Companies welcome",
    if_you_have_tuningcompany_welcome:
      "If you have a tuning company, we welcome you! Please also enter your VAT number if you're a company",
    companies_welcome: "Companies welcome",
    back: "Back",
    next: "Next",
    finish: "Finish",
    email: "Email",
    email_repeat: "Email repeat",
    password: "Password",
    email_must_match: "Email must match",
    first_name: "First Name",
    last_name: "Last Name",
    address_line: "Address line",
    zip_code: "ZIP code",
    city: "City",
    state: "State",
    website_facebook: "Your Website / Facebook",
    company_name: "Company name",
    company: "Company",
    vat_tax_number: "VAT/TAX Number",
    dont_enter_valid_vat_vat_applied:
      "When you don't enter a valid VAT, we cannot do business with you",
    country: "Country",
    select_country: "select country",
    receive_sms_if_applicable: "Receive SMS notifications (if applicable)",
    enter_only_if_you_want_sms:
      "Enter ONLY if you want to receive SMS notifications",
    notifications_optional: "Notifications are optional and not always sent",
    create_password: "Create a password",
    create_password_remember: "create a secure password you can remember",
    repeat: "Repeat",
    agree_terms_conditions: "I agree with the - terms and conditions -",
    you_need_to_agree: "You need to agree",
    id_like_newsletters: "I'd like to receive newsletters",
    registration_success: "Registration successful!",
    you_need_to_agree:
      "You need to agree with our terms and conditions before you can continue",
    email_exists:
      "This email address already exists. Please check your credentials or do a password-reset! If that doesn't work, contact your account manager to reset your account.",
    general_error:
      "Something went wrong badly. Please check all fields and try again. Still no luck? Contact our support",
    upload_now: "Upload now",
    dashboard: "Dashboard",
    fileservice: "Fileservice",
    credits: "Credits",
    support: "Support",
    logout: "Logout",
    openingtimes: "Our openingtimes",
    vehicle_catalog: "Vehicle Catalog",

    at_our_office_the_time: "At our office, the time is",
    my_profile: "My Profile",
    selected_main_tuning_type: "Selected main tuning type",
    name: "Name",
    additional_tuning_types: "Additional tuning types",
    priority_options: "Priority options",
    total_credits: "Total credits",
    credits_may_be_changed:
      "Credits may manually be changed by an engineer - this is only an",
    indication: "indication",
    requested_tuning_fuel: "Requested tuning & Fuel type",
    select_tuning_type: "Select tuning type (select vehicle first)",
    select_fuel_type: "Select fuel type",
    select_additional_tuning_types: "Select optional additional tuning types",
    select_priority: "Select priority",
    select_vehicle_brand: "Select vehicle brand",
    select_vehicle_series: "Select vehicle series",
    select_vehicle_model: "Select vehicle model",
    select_vehicle_engine: "Select vehicle engine",
    year_and_vin: "Year & VIN / Registration number",
    vin_or_registration: "VIN or Registration (please check left)",
    hp_transmission: "HP & Transmission type",
    select_transmission_type: "Select transmission type",
    select_ecu_brand: "Select ECU brand",
    other_unknown: "-- Other / Unknown --",
    manually_enter_ecu_brand: "Manually enter ECU Brand",
    select_ecu_model: "Select ECU model",
    manually_enter_ecu_model: "Manually enter ECU Model",
    select_ecu_type: "Select ECU type",
    manually_enter_ecu_type: "Manually enter ECU Type",
    hardware_numbers: "Hardware numbers",
    software_numbers: "Software numbers",
    software_no_1: "Software #1",
    software_no_2: "Software #2",
    read_method_tuning_tool: "Read method & Tuning tool",
    select_read_method: "Select read method",
    select_tuning_tool: "Select tuning tool",
    tool_type_terms_conditions: "Tool type & Terms + Conditions",
    select_tool_type: "Tool type (slave/master)",
    accept_terms: "Accept terms",
    not_all_fields_entered:
      "Not all fields entered (correctly) - please fix this",
    upload_some_files_first: "Upload some files first",
    complete_your_file_request: "Complete your file request",
    please_wait_files_uploaded:
      "Please wait before your files are uploaded to our server...",
    select_files_to_upload: "Please select files to upload",
    support_case: "Support case",
    not_all_fields_entered:
      "Not all fields entered (correctly) - please fix this",
    upload_some_files_first: "Upload some files first",
    download_all_as_zip: "Download all attachments as ZIP",
    attachment: "Attachment",
    download: "Download",
    send: "Send",
    placeholder_type_reply: "Type your reply here and click the button to send",
    back: "Back",
    print: "Print",
    type_your_reply_and_hit_enter:
      "Type your reply here click the button to send",
    ticket_details: "Ticket details",
    subject: "Subject",
    created_at: "Created at",
    status: "Status",
    file_details: "File details",
    type: "Type",
    unknown: "Unknown",
    download_file: "Download file",
    load_ticket:
      "Please load a ticket from the overview to show the details here",
    description: "Description",
    value: "Value",
    file_code: "File Code",
    upload_date_time: "Upload Date & Time",
    status: "Status",
    completed: "Completed",
    pending: "Pending",
    canceled: "Canceled",
    in_progress: "In progress",
    your_uploaded_files: "Your Uploaded Files",
    file: "File",
    returned_files_by_our_engineers: "Returned Files by Our Engineers",
    vehicle_tuning_information: "Vehicle and tuning information",
    selected_additional_tuning_types: "Selected additional tuning types",
    brand_serie: "Brand & Serie",
    build_engine: "Model & Engine",
    related_tickets: "Related Tickets",
    upload_new: "Upload new",
    special_instructions: "Special instructions",
    overview: "Overview",
    ticket_details: "Ticket details",
    create: "Create",
    new: "New",
    open: "Open",
    create: "Create",
    closed: "Closed",
    deleted_ticket: "Delete ticket",
    vehicle_catalog: "Vehicle Catalog",
    select_vehicle_brand: "Select vehicle brand",
    select_vehicle_series: "Select vehicle series",
    select_vehicle_model: "Select vehicle model",
    engine_name: "Engine name",
    fuel: "Fuel",
    horsepower: "HP",
    code: "Code",
    read_methods: "Read methods",
    ecu: "ECU",
    bore_stroke: "Bore x Stroke",
    optionals: "Optionals",
    print_list: "Print list",
    PAID: "PAID",
    PENDING: "PENDING",
    CANCELED: "CANCELED",
    download_invoice: "Download invoice",
    complete_payment: "Complete payment",
    go_to_fileservice_view_all: "Go to fileservice to view all and download",
    all_times_local_office_times: "All times are our local office times",
    the_clock_left_local_time: "the clock on the left shows our local time",
    day: "Day",
    please_choose_page: "Please choose a page you would like to visit.",
    hello: "Hello",
    forgot_password: "Forgot Password",
    email_address: "Email address",
    enter_email: "Enter email",
    back_to_login: "Back to Login",
    request_reset: "Request Reset",
    buy_credits: "Buy credits",
    credit_transaction_details: "Credit transaction details",
    personal_details: "Personal details",
    additional_info: "Additional Info",
    finish: "Finish",
    only_needed_europe: "(only needed for VAT companies in Europe)",
    transactions: "Transactions",
    your_details: "Your details",
    select_additional_tuning_types_multiple_allowed:
      "Additional tuningtypes (multiple allowed)",
    vehicle_brand_series: "Vehicle brand & series",
    vehicle_build_engine: "Vehicle build & engine",
    coc_kvk_number: "COC / KVK Number",
    sms_notification_number: "SMS Notification number",
    sms_notification_number_leave_empty_disable:
      "SMS Notification number (leave empty to disable)",
    email_address_invoices: "Email address for invoices",
    leave_empty_not_receive_invoice_emails:
      "(leave empty to not receive invoice mails)",
    update_profile: "Update profile",
    notification_settings: "Notification settings",
    sms: "SMS",
    file_uploaded: "File uploaded",
    modified_file_ready_for_download: "Modified file read for download",
    notification_settings: "Notification settings",
    tickets_new_replies: "Tickets (new tickets and replies)",
    sms_only_works_supplier_entered:
      "SMS functionality only works if you have your number entered correctly, and if your supplier supports SMS functionality",
    change_avatar: "Add or change avatar / company logo",
    upload_avatar_here: "Upload avatar/logo image here (max 2MB)",
    detail: "Details",
    please_load_file_overview:
      "Please load a file from the overview to show the details here",
    card_information: "Card information",
    cardholder_name_description: "Click here to type your Cardholder Name",
    total: "Total",
    number: "Number",
    product: "Product",
    price: "Price",
    field: "Field",
    your_customer_id: "Your ID",
    address: "Address",
    zipcode_city: "ZIPcode and city",
    current_credits: "Current balance",
    vat_reverse_charge: "VAT Reverse charge",
    yes: "Yes",
    please_load_transaction_to_show_details:
      "Please load a transaction from the overview to show the details",
    please_load_ticket_to_show_details:
      "Please load a ticket from the overview to show it's details",
    something_went_wrong_sending_ticket:
      "Something went wrong. It looks like the ticket data cannot be found. Please contact us if needed.",
    error: "Error",
    reply_sent: "Reply sent!",
    engineers_will_reply_asap:
      "Our engineers will reply you as soon as possible (if needed)",
    support_team: "Support team",
    date_and_time: "Date and Time",
    type_country: "Customer type and Country",
    comments: "Comments",
    rolled_back: "rolled back",
    payment_verified_completed:
      "The payment has been verified and completed, thank you very much! You can now go and upload files. You can download the invoice in the transactions overview.",
    payment_completed: "Payment completed!",
    error_could_not_verify_payment:
      "An error occured. We could not verify the payment. Please send us a support ticket and we will help you out!",
    please_wait_verifying_payment:
      "Please wait while we're verifying your payment",
    payment_is_pending_need_completed:
      "Your payment is pending and needs to be completed before you can continue.",
    thank_you_payment_completed: "Thank you! Your payment is completed.",
    transaction_already_processed:
      "This payment is already processed. Please check your creditbalance or create a new payment.",
    transaction_failed:
      "The transaction failed or has been canceled. Please try again.",
    transaction_canceled:
      "The transaction has been canceled. You need to create a new one to add credits.",
    transaction_error:
      "This transaction could not be found. Please create a new one, or send u a support ticket if this doesn't resolve your problem.",
    click_transaction_overview:
      "Click here to go back to the transactions overview",
    please_wait: "Please wait",
    your_browser_being_redirected: "Your browser is being redirected",
    click_here: "If not, then click here",
    file_update_detected:
      "File update detected, please go to the file overview to see the updates",
    ticket_replied_view_tickets:
      "Ticket replied. Please visit the tickets to see the update!",
    your_credits_are_too_low_for_specified_options_buy_new:
      "Your credit balance is not sufficient for the selected tuning types and options. Please first buy more credits before uploading.",
    email_verified_succesfully:
      "Your email address has been validated succesfully",
    too_many_attempts_try_again_later: "Too many attempts. Try again later.",
    error_login_email_unverified:
      "Sorry, we could not log you in. Your email address is not yet verified. Please click the button below the login form to re-submit the welcome email. You must click the button in the welcome email to verify your email address!",
    resend_verification_email: "Resubmit welcome / verification email",
    email_sent_check_inbox:
      "Email sent. Please check your inbox (and spam folder)",
    email_verification_failed_token_invalid:
      "The verification token is invalid. Please click the button to re-send the welcome email with a new link in it to retry verification.",
    please_enter_your_email_address_first:
      "Please enter your email address before requesting a new verification email.",
    something_went_wrong_verifying:
      "Something went wrong verifying your email address. Please contact support via email.",
    vat_is_required: "A valid VAT number is required to do business with us",
    additional_payment_fee: "Additional payment fee",
    whoops: "Whoops!",
    engine: "Engine"
  },
  es: {
    whoops: "Algo salió mal",
    login: "Iniciar sesión",
    email_address: "Correo electrónico",
    password: "Contraseña",
    toggle_navigation: "Alternar navegación",
    login_failed_try_or_reset:
      "Fallo al iniciar sesión. Intente nuevamente o restablezca su contraseña",
    lets_go: "¡Vamos!",
    create_account: "Crear cuenta",
    forgot_your_password: "¿Olvidó su contraseña?",
    forgot_password: "¿Olvidó su contraseña?",
    register: "Registrarse",
    logged_out: "Sesión cerrada",
    logged_in: "Sesión iniciada",
    sorry_login_failed_check_credentials:
      "Lo sentimos, no se pudo iniciar sesión. Verifique sus credenciales o restablezca su contraseña. Si aún no puede iniciar sesión, comuníquese con su gerente de cuenta",
    back_to_login: "Volver al inicio de sesión",
    request_reset: "Solicitar restablecimiento",
    request_sent_please_check_mailbox:
      "Solicitud enviada - por favor revise su correo electrónico para el enlace de restablecimiento",
    something_went_wrong_check_email:
      "Algo salió mal. Por favor revise su dirección de correo electrónico.",
    looking_to_login: "¿Buscando iniciar sesión?",
    register_today_start_uploading:
      "Regístrese hoy y comience a cargar sus archivos",
    great: "Genial",
    almost_on_board:
      "Casi estás a bordo, ¡sigue el asistente de registro y vamos!",
    free_account: "Cuenta gratuita",
    creating_account_is_free:
      "Crear una cuenta es gratuito. Luego, puede elegir algunos créditos que desea comprar para comenzar a cargar archivos.",
    awesome_performances: "Increíbles rendimientos",
    we_provide_fast_stable_fileservice:
      "Le proporcionamos un servicio de archivo rápido y estable. Puede ayudar a sus clientes de manera fácil y eficiente",
    friendly_support: "Soporte amigable",
    we_can_help_issues:
      "Podemos ayudarlo con problemas a través de nuestro sistema de tickets",
    companies_welcome: "Bienvenidas empresas",
    if_you_have_tuningcompany_welcome:
      "Si tiene una empresa de ajuste, ¡lo invitamos! También ingrese su número de IVA si es una empresa",
    companies_welcome: "Bienvenidas empresas",
    back: "Atrás",
    next: "Siguiente",
    finish: "Finalizar",
    email: "Correo electrónico",
    email_repeat: "Repetir correo electrónico",
    password: "Contraseña",
    email_must_match: "El correo electrónico debe coincidir",
    first_name: "Nombre",
    last_name: "Apellido",
    address_line: "Línea de dirección",
    zip_code: "Código postal",
    city: "Ciudad",
    state: "Estado",
    website_facebook: "Su sitio web / Facebook",
    company_name: "Nombre de la empresa",
    company: "Empresa",
    vat_tax_number: "Número de CIF/DNI/NIE",
    dont_enter_valid_vat_vat_applied:
      "Cuando no ingreses un número de CIF/DNI/NIE válido, no podemos hacer negocios contigo.",
    country: "País",
    select_country: "Seleccionar país",
    receive_sms_if_applicable:
      "Recibir notificaciones por SMS (si corresponde)",
    enter_only_if_you_want_sms: "Ingrese SOLO si",
    upload_now: "Subir ahora",
    dashboard: "Tablero",
    fileservice: "Servicio de Archivos",
    credits: "Créditos",
    support: "Soporte",
    logout: "Cerrar sesión",
    openingtimes: "Nuestro horario de servicios",
    vehicle_catalog: "Catálogo de vehículos",
    at_our_office_the_time: "En nuestra oficina, la hora es",
    my_profile: "Mi perfil",
    selected_main_tuning_type: "Tipo principal de ajuste seleccionado",
    name: "Nombre",
    additional_tuning_types: "Tipos de ajustes adicionales",
    priority_options: "Opciones de prioridad",
    total_credits: "Créditos totales",
    credits_may_be_changed:
      "Los créditos pueden ser cambiados manualmente por un ingeniero - esto es solo una",
    indication: "indicación",
    requested_tuning_fuel: "Tipo de ajuste y combustible solicitado",
    select_tuning_type:
      "Seleccionar tipo de ajuste (seleccionar vehículo primero)",
    select_fuel_type: "Seleccionar tipo de combustible",
    select_additional_tuning_types:
      "Seleccionar tipos de ajustes adicionales opcionales",
    select_priority: "Seleccionar prioridad",
    select_vehicle_brand: "Seleccionar marca de vehículo",
    select_vehicle_series: "Seleccionar serie de vehículo",
    select_vehicle_model: "Seleccionar modelo de vehículo",
    select_vehicle_engine: "Seleccionar motor de vehículo",
    year_and_vin: "Año y número de VIN / Registro",
    vin_or_registration: "VIN o Registro (por favor, compruebe a la izquierda)",
    hp_transmission: "HP y tipo de transmisión",
    select_transmission_type: "Seleccionar tipo de transmisión",
    select_ecu_brand: "Seleccionar marca de ECU",
    other_unknown: "-- Otro / Desconocido --",
    manually_enter_ecu_brand: "Ingresar manualmente la marca de la ECU",
    select_ecu_model: "Seleccionar modelo de ECU",
    manually_enter_ecu_model: "Ingresar manualmente el modelo de la ECU",
    select_ecu_type: "Seleccionar tipo de ECU",
    manually_enter_ecu_type: "Ingresar manualmente el tipo de ECU",
    hardware_numbers: "Números de hardware",
    software_numbers: "Números de software",
    software_no_1: "Software n.° 1",
    software_no_2: "Software n.° 2",
    read_method_tuning_tool: "Método de lectura y herramienta de ajuste",
    select_read_method: "Seleccionar método de lectura",
    select_tuning_tool: "Seleccionar herramienta de ajuste",
    tool_type_terms_conditions: "Tipo de herramienta y términos y condiciones",
    select_tool_type: "Tipo de herramienta (esclava / maestra)",
    accept_terms: "Aceptar términos",
    not_all_fields_entered:
      "No se han ingresado todos los campos (correctamente): por favor, solucionar esto",
    upload_some_files_first: "Cargar algunos archivos primero",
    complete_your_file_request: "Complete su solicitud de archivo",
    please_wait_files_uploaded:
      "Por favor, espere mientras sus archivos se cargan en nuestro servidor ...",
    select_files_to_upload: "Seleccione archivos para cargar",
    support_case: "Caso de soporte",
    not_all_fields_entered:
      "No se han ingresado todos los campos (correctamente): por favor, solucionar esto",
    upload_some_files_first: "Cargar algunos archivos primero",
    download_all_as_zip: "Descargar todos los archivos adjuntos como ZIP",
    attachment: "Archivo adjunto",
    download: "Descargar",
    send: "Enviar",
    placeholder_type_reply:
      "Lo siento, pero no veo ninguna pregunta o mensaje anterior en esta conversación para responder. ¿Hay algo en lo que pueda ayudarte?",
    back: "Atrás",
    print: "Imprimir",
    type_your_reply_and_hit_enter:
      "Lo siento, pero no veo ninguna pregunta o mensaje anterior en esta conversación para responder. ¿Hay algo en lo que pueda ayudarte?",
    ticket_details: "Detalles del ticket",
    subject: "Asunto",
    created_at: "Creado en",
    status: "Estado",
    file_details: "Detalles del archivo",
    type: "Tipo",
    unknown: "Desconocido",
    download_file: "Descargar archivo",
    load_ticket:
      "Cargue un ticket desde la descripción general para mostrar los detalles aquí",
    description: "Descripción",
    value: "Valor",
    file_code: "Código de archivo",
    upload_date_time: "Fecha y hora de carga",
    status: "Estado",
    completed: "Completado",
    pending: "Pendiente",
    canceled: "Cancelado",
    in_progress: "En progreso",
    your_uploaded_files: "Sus archivos cargados",
    file: "Archivo",
    returned_files_by_our_engineers:
      "Archivos devueltos por nuestros ingenieros",
    vehicle_tuning_information: "Información de ajuste y vehículo",
    selected_additional_tuning_types:
      "Tipos de ajuste adicionales seleccionados",
    brand_serie: "Marca y serie",
    build_engine: "Modelo y motor",
    related_tickets: "Tickets relacionados",
    upload_new: "Cargar nuevo",
    special_instructions: "Instrucciones especiales",
    overview: "Visión general",
    ticket_details: "Detalles del ticket",
    create: "Crear",
    new: "Nuevo",
    open: "Abierto",
    closed: "Cerrado",
    deleted_ticket: "Eliminar ticket",
    vehicle_catalog: "Catálogo de vehículos",
    select_vehicle_brand: "Seleccionar marca de vehículo",
    select_vehicle_series: "Seleccionar serie de vehículo",
    select_vehicle_model: "Seleccionar modelo de vehículo",
    engine_name: "Nombre del motor",
    fuel: "Combustible",
    horsepower: "CV",
    code: "Código",
    read_methods: "Métodos de lectura",
    ecu: "ECU",
    bore_stroke: "Carrera x Diámetro",
    optionals: "Opcionales",
    print_list: "Imprimir lista",
    PAID: "PAGADO",
    PENDING: "PENDIENTE",
    CANCELED: "CANCELADO",
    download_invoice: "Descargar factura",
    complete_payment: "Completar pago",
    go_to_fileservice_view_all:
      "Ir al servicio de archivos para ver y descargar todo",
    all_times_local_office_times:
      "Todas las horas son horas de nuestra oficina local",
    the_clock_left_local_time:
      "el reloj a la izquierda muestra nuestra hora local",
    day: "Día",
    please_choose_page: "Por favor elige una página que te gustaría visitar.",
    hello: "Hola",
    forgot_password: "¿Olvidaste tu contraseña?",
    email_address: "Dirección de correo electrónico",
    enter_email: "Ingresa tu correo electrónico",
    back_to_login: "Volver al inicio de sesión",
    request_reset: "Solicitar restablecimiento",
    buy_credits: "Comprar créditos",
    credit_transaction_details: "Detalles de la transacción de crédito",
    personal_details: "Detalles personales",
    additional_info: "Información adicional",
    finish: "Finalizar",
    only_needed_europe: "(solo necesario para empresas de IVA en Europa)",
    transactions: "Facturas",
    create_password: "Crea una contraseña",
    create_password_remember: "Crea una contraseña segura que puedas recordar",
    repeat: "Repetir",
    agree_terms_conditions:
      "Estoy de acuerdo con los - términos y condiciones -",
    you_need_to_agree: "Debes estar de acuerdo",
    id_like_newsletters: "Me gustaría recibir boletines",
    registration_success:
      "Registro exitoso. Por favor, verifica tu dirección de correo electrónico en el correo de bienvenida que acabamos de enviarte. Por favor, revisa tu bandeja de correo no deseado si no lo encuentras.",
    you_need_to_agree:
      "Debes aceptar nuestros términos y condiciones antes de continuar",
    email_exists:
      "Esta dirección de correo electrónico ya existe. ¡Por favor verifica tus credenciales o haz un restablecimiento de contraseña! Si eso no funciona, comunícate con tu gerente de cuenta para restablecer tu cuenta.",
    general_error:
      "Algo salió muy mal. Por favor verifica todos los campos e intenta nuevamente. ¿Todavía no tienes suerte? Comunícate con nuestro soporte",
    your_details: "tus detalles",
    select_additional_tuning_types_multiple_allowed:
      "TuningTypes adicionales (múltiples permitidos) (opcional)",
    vehicle_brand_series: "Marca y serie de vehículos",
    vehicle_build_engine: "Construcción y motor del vehículo",
    gasoline: "gasolina",
    diesel: "diesel",
    lpg: "LPG",
    hybrid: "híbrido",
    electric: "eléctrico",
    other_unknown: "Otro/desconocido",
    ecu_specifications: "Especificaciones de ECU",
    special_instructions_put_here:
      "Si tiene instrucciones o mensajes especiales para nuestros ingenieros, póngalos aquí.",
    coc_kvk_number: "número de la Cámara de Comercio",
    sms_notification_number: "Número de notificación de SMS",
    sms_notification_number_leave_empty_disable:
      "Número de notificación SMS (deje vacío para deshabilitar)",
    email_address_invoices: "Dirección de correo electrónico para facturas",
    leave_empty_not_receive_invoice_emails:
      "(Deje vacío para no recibir correos de factura)",
    update_profile: "Actualización del perfil",
    notification_settings: "Configuración de las notificaciones",
    file_uploaded: "Archivo cargado con éxito",
    modified_file_ready_for_download: "Archivo modificado listo para descargar",
    tickets_new_replies: "Entradas (nuevas entradas y respuestas)",
    sms_only_works_supplier_entered:
      "La funcionalidad SMS solo funciona si tiene su número ingresado correctamente, y si su proveedor admite la funcionalidad SMS",
    change_avatar: "Agregar o cambiar el logotipo de Avatar / Company",
    upload_avatar_here: "Cargue la imagen de avatar/logotipo aquí (máximo 2mb)",
    detail: "Detalle",
    please_load_file_overview:
      "Cargue un archivo de la descripción general para mostrar los detalles aquí",
    card_information: "Información de la tarjeta",
    cardholder_name_description:
      "Haga clic aquí para escribir su nombre de titular de la tarjeta",
    total: "Total",
    number: "número",
    product: "producto",
    price: "precio",
    field: "campo",
    your_customer_id: "tu identificación",
    address: "dirección",
    zipcode_city: "código postal y ciudad",
    current_credits: "creditos actuales",
    vat_reverse_charge: "Reversión del IVA",
    yes: "Sí",
    please_load_transaction_to_show_details:
      "Cargue una transacción de la descripción general para mostrar los detalles",
    please_load_ticket_to_show_details:
      "Cargue un ticket de la descripción general para mostrar sus detalles",
    create_new_ticket: "Create new ticket",
    you_need_to_select_file: "You need to select a file",
    date: "Date",
    message: "mensaje",
    submit: "entregar",
    tuning_type: "Tipo de afinación",
    uploaded_files: "Archivos subidos",
    vehicle_type: "Tipo de vehículo",
    select_vehicle_type: "seleccione el tipo de vehículo",
    Cars: "Coches",
    Trucks: "Camiones",
    Motorboats: "Barcos",
    "Bikes & Quads": "Motos y Quads",
    "Jet ski's": "Motos de agua",
    "Tractors & Agriculture": "Tractores y Agricultura",
    something_went_wrong_sending_ticket:
      "Algo salió mal. Parece que no se pueden encontrar los datos del ticket. Póngase en contacto con nosotros si es necesario.",
    error: "Error",
    success: "Éxito",
    reply_sent: "¡Respuesta enviada!",
    engineers_will_reply_asap:
      "Nuestros ingenieros le responderán lo antes posible (si es necesario)",
    files_uploaded: "Archivo(s) subido(s)",
    support_team: "Equipo de apoyo",
    date_and_time: "Fecha y hora",
    type_country: "Tipo de cliente y país",
    comments: "comentarios",
    added: "agregado",
    taken: "tareas",
    business: "negocio",
    individual: "individual",
    rolled_back: "retrotraído",
    payment_verified_completed:
      "El pago ha sido verificado y completado, ¡muchas gracias! Ahora puede ir y cargar archivos. Puede descargar la factura en el resumen de transacciones.",
    payment_completed: "¡Pago completado!",
    payment_failed_unknown_error:
      "El pago falló debido a un error desconocido. Detalles (en inglés):",
    additional_payment_fee: "tarifa de pago adicional",
    error_could_not_verify_payment:
      "Ocurrió un error. No pudimos verificar el pago. ¡Envíanos un ticket de soporte y te ayudaremos!",
    please_wait_verifying_payment: "Espere mientras verificamos su pago",
    payment_is_pending_need_completed:
      "Su pago está pendiente y debe completarse antes de que pueda continuar.",
    thank_you_payment_completed: "¡Gracias! Su pago está completo.",
    transaction_already_processed:
      "Este pago ya está procesado. Verifique su saldo de crédito o cree un nuevo pago.",
    transaction_failed:
      "La transacción falló o ha sido cancelada. Inténtalo de nuevo.",
    transaction_canceled:
      "La transacción ha sido cancelada. Necesita crear uno nuevo para agregar créditos.",
    transaction_error:
      "No se pudo encontrar esta transacción. Cree uno nuevo o envíe un ticket de soporte si esto no resuelve su problema.",
    click_transaction_overview:
      "Haga clic aquí para volver al resumen de transacciones",
    please_wait: "Espere por favor",
    your_browser_being_redirected: "Su navegador está siendo redirigido",
    click_here: "Si no, entonces haga clic aquí",
    file_update_detected:
      "Actualización de archivo detectada, vaya a la descripción general del archivo para ver las actualizaciones",
    ticket_replied_view_tickets:
      "Respondió el boleto. ¡Visita las entradas para ver la actualización!",
    price_list: "Lista de precios",
    your_credits_are_too_low_for_specified_options_buy_new:
      "Tu saldo de crédito no es suficiente para los tipos de ajuste y opciones seleccionados. Por favor, compra más créditos antes de cargar.",
    already_processed: "Ya procesado",
    vat: "CIF/DNI/NIE",
    please_read_clicking_link:
      "Por favor, léelos haciendo clic en el enlace junto a la casilla de verificación",
    take_longer: "Tarda más tiempo",
    status_updates: "Actualizaciones de estado",
    accept_terms_before_continue:
      "Por favor, acepta nuestros términos y condiciones antes de continuar",
    email_verified_succesfully:
      "Tu dirección de correo electrónico ha sido validada exitosamente!",
    too_many_attempts_try_again_later:
      "Demasiados intentos. Intenta de nuevo en un minuto. Si el problema persiste, contáctanos por correo electrónico.",
    error_login_email_unverified:
      'Lo sentimos, no pudimos iniciar sesión. La dirección de correo electrónico no ha sido validada aún. Por favor, revisa tu carpeta de spam o haz clic en la opción "Validar correo electrónico nuevamente" en la pantalla para recibir nuevamente el correo de bienvenida con un código de validación. ¡En el correo electrónico, debes hacer clic en el botón para validar la dirección de correo electrónico!',
    resend_verification_email: "Vuelve a enviar el correo de verificación.",
    email_sent_check_inbox:
      "Correo electrónico enviado. Por favor, revisa tu bandeja de entrada (y la carpeta de spam).",
    email_verification_failed_token_invalid:
      "El token de verificación no es válido. Por favor, haz clic en el botón para reenviar el correo electrónico de bienvenida con un nuevo enlace e intentar la verificación nuevamente.",
    please_enter_your_email_address_first:
      "Por favor, ingresa tu dirección de correo electrónico antes de solicitar un nuevo correo de verificación.",
    sorry_this_address_is_already_verified:
      "Lo siento, esta dirección de correo electrónico ya ha sido verificada",
    something_went_wrong_verifying:
      "Algo salió mal al verificar tu dirección de correo electrónico. Póngase en contacto con el soporte por correo electrónico.",
    vat_is_required:
      "Se requiere un número de CIF/DNI/NIE válido para hacer negocios con nosotros."
  }
};

export default messages;



// WEBPACK FOOTER //
// ./src/i18n.js